import { methodGet, methodPost } from "../../helper";
import moment from "moment";
import Chart from "chart.js/auto";

export async function checkIfAllowedToRespond(formType) {
  return new Promise((resolve, reject) => {
    let code = localStorage.getItem("lien");
    if (!code) {
      reject();
    } else {
      methodGet("/getLink.php?linkCode=" + code)
        .then((res) => {
          if (!res[0] || parseInt(res[0].formType) !== formType) reject();
          else resolve();
        })
        .catch((err) => {
          if (window.location.host === "localhost:3000" || window.location.host === "192.168.0.17:3000") resolve();
          else reject(err);
        });
    }
  });
}

export async function onCompleted(reponses, navigate) {
  localStorage.setItem("reponses", JSON.stringify(reponses));
  localStorage.setItem("completed", JSON.stringify(reponses));
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  methodPost("/save.php", {
    ...userInfo,
    reponse: JSON.stringify(reponses),
    date: moment().format("YYYY-MM-DD HH:mm:ss"),
  });

  navigate("/completed/" + userInfo.formType);
}

export function restartQuiz(navigate) {
  localStorage.removeItem("reponses");
  localStorage.removeItem("completed");
  let code = localStorage.getItem("lien");
  if (code) {
    navigate("/?code=" + code);
  } else navigate("/");
}

export function isAllResponded(reponses) {
  let missing = false;

  for (let index = 0; index < reponses.length; index++) {
    const element = reponses[index];
    element.forEach((res) => {
      if (res.score === undefined) missing = true;
    });
  }
  return !missing;
}

export function drawRadarChart(idParentChart, data, labels) {
  let parentCanvas = document.getElementById(idParentChart);
  let canvas = document.createElement("canvas");
  canvas.id = idParentChart;
  canvas.style = '{{ display: "block", width: "100%" }}';
  canvas.className = "chartjs-render-monitor";
  parentCanvas.appendChild(canvas);
  const ctx = canvas.getContext("2d");
  const myChart = new Chart(ctx, {
    type: "radar",
    data: {
      labels: labels,
      datasets: [
        {
          data: data,
          fill: true,
          backgroundColor: "rgba(0, 143, 144, 0.2)",
          borderColor: "rgb(0, 143, 144)",
          pointBackgroundColor: "rgb(0, 143, 144)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgb(0, 143, 144)",
        },
      ],
    },
    options: {
      elements: {
        line: {
          borderWidth: 3,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      scale: {
        r: {
          min: 0,
          max: Math.max(...data) + Math.round(Math.max(...data) * .2),
          beginAtZero: true,
        },
      },
    },
  });
}

export function findNotResponded(reponses, navigate) {
  for (let index = 0; index < reponses.length; index++) {
    const element = reponses[index];
    let notResponse = element.filter((res) => res.score === undefined);
    if (notResponse.length > 0) {
      navigate("#" + (index + 1).toString());
      break;
    }
  }
}